import { getIcon } from './getIcon';
export const createRewardTooltipItem = (reward, isBorrow = false) => {
    const tokenSymbol = reward.token.split('::').pop() || reward.token;
    const tokenLowerCase = tokenSymbol.toLowerCase();
    const isSui = reward.token.endsWith('::sui::SUI');
    const displayLabel = tokenSymbol === 'staking_apr'
        ? 'Staking'
        : tokenSymbol.toUpperCase() === 'STSUI'
            ? 'stSUI'
            : tokenSymbol;
    const icon = tokenSymbol === 'staking_apr' || isSui
        ? getIcon('stsui')
        : getIcon(tokenLowerCase);
    const value = isBorrow ? `[${reward.apr}%]` : `${reward.apr}%`;
    return {
        icon,
        label: isSui ? 'Yield APR' : `${displayLabel} APR`,
        value,
    };
};
export const generateSupplyTooltipItems = (supplyAprData, marketSymbol) => {
    if (!supplyAprData)
        return undefined;
    const tooltipItems = [];
    if (supplyAprData.interest) {
        tooltipItems.push({
            icon: getIcon(marketSymbol === null || marketSymbol === void 0 ? void 0 : marketSymbol.toLowerCase()),
            label: 'Supply APR',
            value: `${supplyAprData.interest}%`,
        });
    }
    if (supplyAprData.rewards && supplyAprData.rewards.length > 0) {
        supplyAprData.rewards.forEach((reward) => {
            tooltipItems.push(createRewardTooltipItem(reward, false));
        });
    }
    if (tooltipItems.length > 0 && supplyAprData.total) {
        tooltipItems.push({
            icon: '',
            label: 'TOTAL APR',
            value: `${supplyAprData.total}%`,
        });
    }
    return tooltipItems.length > 0 ? tooltipItems : undefined;
};
export const generateBorrowTooltipItems = (borrowAprData, marketSymbol) => {
    if (!borrowAprData)
        return undefined;
    const tooltipItems = [];
    if (borrowAprData.interest) {
        tooltipItems.push({
            icon: getIcon(marketSymbol === null || marketSymbol === void 0 ? void 0 : marketSymbol.toLowerCase()),
            label: 'Borrow APR',
            value: `${borrowAprData.interest}%`,
        });
    }
    if (borrowAprData.rewards && borrowAprData.rewards.length > 0) {
        borrowAprData.rewards.forEach((reward) => {
            tooltipItems.push(createRewardTooltipItem(reward, true));
        });
    }
    if (tooltipItems.length > 0 && borrowAprData.total) {
        tooltipItems.push({
            icon: '',
            label: 'TOTAL APR',
            value: `${borrowAprData.total}%`,
        });
    }
    return tooltipItems.length > 0 ? tooltipItems : undefined;
};
